import { computed, unref, useContext } from '@nuxtjs/composition-api'
import { MaybeRef } from '@vueuse/core'

import Store from '@/classes/Store'

export default function (store: MaybeRef<Store | null>) {
  const { query, localePath } = useContext()

  return computed(() => {
    const link = unref(store)?.commentLink
    if (!link) return
    return localePath({
      path: link,
      query: query.value,
    })
  })
}
